module.exports = __webpack_public_path__ + "img/giftcard_details_failed.10bedcf3.svg";